<script>
  // A group as a pill: its icon (shared/Avatar, the group's colored initial
  // when it has no icon), its name, and optionally its member count. A button
  // when the caller gives `onclick` (the User Page's Shared groups), else a
  // static label (the People tab's chips, `active` marking the picked group).
  // `size`: 'md' on the User Page, 'sm' inline beside a name.
  import Avatar from './Avatar.svelte';

  /**
   * @type {{
   *   group: { groupId: string, name: string, iconUrl?: string | null },
   *   count?: number | null,
   *   size?: 'md' | 'sm',
   *   active?: boolean,
   *   onclick?: ((e: MouseEvent) => void) | null,
   * }}
   */
  let { group, count = null, size = 'md', active = false, onclick = null } = $props();
</script>

{#snippet body()}
  <span class="group-chip-icon" aria-hidden="true">
    <Avatar id={group.groupId} name={group.name} photoUrl={group.iconUrl ?? null} />
  </span>
  <span class="group-chip-name">{group.name}</span>
  {#if count != null}<span class="group-chip-count">{count}</span>{/if}
{/snippet}

{#if onclick}
  <button class="group-chip {size}" class:active {onclick}>{@render body()}</button>
{:else}
  <span class="group-chip {size}" class:active>{@render body()}</span>
{/if}

<style>
  .group-chip {
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--color-border);
    border-radius: 999px;
    font-family: inherit;
    color: var(--color-text);
  }
  .group-chip-icon {
    display: inline-flex;
  }
  .group-chip-name {
    font-weight: 500;
  }

  .md {
    gap: 8px;
    padding: 5px 12px 5px 5px;
    background: var(--color-bg-surface);
    font-size: 14px;
    --avatar-size: 26px;
    --avatar-font-size: 12px;
  }
  .sm {
    gap: 5px;
    padding: 2px 9px 2px 2px;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-text-secondary);
    --avatar-size: 18px;
    --avatar-font-size: 10px;
  }
  .sm.active {
    border-color: var(--color-accent-dark);
    color: var(--color-text);
  }

  button.group-chip {
    cursor: pointer;
    transition:
      border-color var(--dur-fast) var(--ease-standard),
      box-shadow var(--dur-fast) var(--ease-standard);
  }
  button.group-chip:hover {
    border-color: var(--color-text-muted);
    box-shadow: 0 2px 8px rgba(40, 30, 15, 0.06);
  }

  .group-chip-count {
    font-size: 12px;
    color: var(--color-text-tertiary);
  }
</style>
